import styled from 'styled-components'

export const Container = styled.header`
  align-items: center;
  background-color: var(--white);
  display: flex;
  height: 88px;
  justify-content: space-between;
  padding: 24px 62px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 10;

  figure img {
    width: fit-content;
  }

  @media (max-width: 1180px) {
    padding-inline: 40px;
  }

  @media (max-width: 951px) {
    padding: 16px 32px;
  }
`

export const DesktopContent = styled.div`
  display: flex;
  gap: 62px;

  @media (max-width: 1180px) {
    gap: 32px;

    button {
      font-size: 18px;
      line-height: 24px;
    }
  }

  @media (max-width: 951px) {
    display: none;
  }
`

export const NavList = styled.nav`
  display: flex;
  flex: 1;

  ul {
    align-items: center;
    display: flex;
    gap: 32px;
    list-style: none;

    li {

      a {
        color: #23163B;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        transition: ease-in 600ms;
        white-space: nowrap;

        &:hover {
          color: #7649C6;
        }
      }
    }
  }

  @media (max-width: 1180px) {
    ul {
      gap: 20px;
    }
  }

  @media (max-width: 950px) {
    ul {
      align-items: flex-start;
      flex-direction: column;
      gap: 16px;
    }
  }
`

export const MobileContent = styled.div`
  display: none;
  width: 100%;

  @media (max-width: 950px) {
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }
`

export const MobileMenuToggle = styled.div`
  background-color: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 8px;
  outline: none;
  width: fit-content;
  cursor: pointer;

  > div {
    background-color: var(--primary);
    border-radius: 20px;
    height: 4px;
    width: 32px;
    transition: transform 0.8s ease, background-color 0.8s ease;
  }

  &.open > div:nth-child(1) {
    transform: translateY(10px) rotate(45deg);
  }

  &.open > div:nth-child(2) {
    transform: translateY(2px) rotate(-45deg);
  }

  &.open > div:nth-child(3) {
    transform: translateY(-6px) rotate(-45deg);
  }
`

export const MobileMenuContainer = styled.div<{ $menuOpen: boolean }>`
  background-color: var(--white);
  height: ${({ $menuOpen }) => $menuOpen ? '100%' : 0};
  left: 0;
  max-height: 232px;
  overflow-x: hidden;
  position: fixed;
  top: 88px;
  transition: ease-in-out .8s;
  width: 100%;
  z-index: 10;
`

export const MobileMenuContent = styled.div`
  display: grid;
  grid-template-rows: 1fr 4fr 1fr;
  height: 100%;
  padding: 24px 32px;
  width: 100%;
`
